import React from "react";
import "./index.less";

const InfoCard = (props) => {
  const { title, children, extra } = props;

  return (
    <div className="card">
      <div className="card-title-area">
        <div className="card-title">{title}</div>
        <div className="card-extra">{extra}</div>
      </div>
      <div className="card-content-area">{children}</div>
    </div>
  );
};

export default InfoCard;
